import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Label, Translate } from '@hydra/common/components';
import { Grid } from '@material-ui/core';
import get from 'lodash/get';

import List from '@hydra/routes/crawler/components/List';

import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';

export class CrawlErrorsRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;
    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const issueUrl = new DCUrl(domain, issue.url);
    const sourceUrl = new DCUrl(domain, issue.source_url);
    const error = issue.error === 'crawler_infrastructure_error'
      ? <Translate content='crawler_infrastructure_error' />
      : issue.error;

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <Label style={parseSeverity(issue.severity)} noBackground truncate>
            <strong>
              {error}
            </strong>
          </Label>
        </Grid>
        <Grid item {...columnStyles[1]}>
          <List style={parseSeverity(issue.severity)} items={sourceUrl} />
        </Grid>
        <Grid item {...columnStyles[2]}>
          <List style={parseSeverity(issue.severity)} items={issueUrl} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(CrawlErrorsRow, {
  issue: graphql`
    fragment CrawlErrorsRow_issue on CrawlError {
      id
      type
      source_url
      severity
      error
      url
    }
  `
});
